import ObjectCache from './CacheService';
import LogicBaseUserReportApi from '../server/LogicBaseUserReportApi';
import UserAccount from '../UserAccount';
import LogicBaseUserReport from '../../models/logicbaseuserreport';

class LogicBaseUserReportCache extends ObjectCache {
  api = LogicBaseUserReportApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseUserReport(results._id, results.o, results.u, results.d, results.s);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseUserReportCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
